import { render } from "./SimpleMlfsTable.vue?vue&type=template&id=77d47c8e"
import script from "./SimpleMlfsTable.vue?vue&type=script&lang=js"
export * from "./SimpleMlfsTable.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./SimpleMlfsTable.vue?vue&type=style&index=0&id=77d47c8e&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script